module.exports = __webpack_public_path__ + "img/32.34a790d8.svg";